module.exports = __webpack_public_path__ + "static/media/stripe-logo.3039ec9c.svg";